export default {"theme":{"options":{"customProperties":true},"themes":{"light":{"base":"#9e9e9e","primary":"#212121"},"dark":{"base":"#9e9e9e","primary":"#37474f"}}}}
